import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: HTMLIonLoadingElement;
  constructor(public loadingCtrl: LoadingController, private translateService: TranslateService) {}

  async present(message: string = 'PLEASE_WAIT', keyboardClose: boolean = false, duration: number = 5000) {
    if (this.loading) {
      await this.dismiss();
    }
    let loadingMsg = this.translateService.instant(message);
    this.loading = await this.loadingCtrl.create({
      duration: duration,
      message: loadingMsg,
      keyboardClose,
    });
    return await this.loading.present();
  }
  async presentForLongTime(message: string = 'PLEASE_WAIT', keyboardClose: boolean = false) {
    if (this.loading) {
      await this.dismiss();
    }
    let loadingMsg = this.translateService.instant(message);
    this.loading = await this.loadingCtrl.create({
      duration: 300000,
      message: loadingMsg,
      keyboardClose,
    });
    return await this.loading.present();
  }

  async dismiss() {
    if (!this.loading) {
      return;
    } else {
      await this.loading.dismiss();
      delete this.loading;
      return;
    }
  }
}
